import { AxiosError } from 'axios';

export const getErrorReason = (errors: (string | undefined)[]): string => {
  const hasErrors = Array.isArray(errors) && errors.length > 0;

  if (!hasErrors) {
    return '';
  }

  const error = errors.filter((e) => e);

  if (error.length > 0) return error[0] as string;

  return '';
};

export const getAxiosError = (error: AxiosError): string => {
  const err = error as AxiosError<{ error: string; message: string; statusCode: number }>;
  if (err.response) {
    const { error: axiosError, message, statusCode } = err.response.data;

    return `[${statusCode}][${axiosError}] ${message}`;
  }

  return err.message;
};
